import { graphql } from '../../../../graphql/generated';

export const UPDATE_DIAGNOSE_MUTATION = graphql(`
  mutation UpdateDiagnose($id: ID!, $input: DiagnoseUpdateInput!) {
    updateDiagnose(id: $id, input: $input) {
      id
    }
  }
`);
